"use strict";

$(document).ready(function () {
  var page;
  var templateId = $('body').data('template');

  /*
   * Init Nette JS
   */
  $.nette.init();

  /*
   * Init page controller by template
   */
  switch (templateId) {
    case 'homepage':
      page = new HomepageController();
      break;
    case 'news':
      page = new NewsController();
      break;
    case 'termsofuse':
      page = new TermsOfUseController();
      break;
    case 'privacypolicy':
      page = new PrivacyPolicyController();
      break;
    case 'quality-assurance':
      page = new QualityAssuranceController();
      break;
    case 'stories-detail':
      page = new StoriesDetailController();
      break;
    case 'search':
      page = new SearchController();
      break;
    case 'contact':
      page = new ContactController();
      break;
    case 'ebooks':
      page = new EbooksController();
      break;
    case 'educationtechnology':
      page = new EducationTechnologyController();
      break;
    case 'aboutus':
      page = new AboutUsController();
      break;
    case 'software-solutions':
      page = new SoftwareSolutionsController();
      break;
    case 'news-detail':
      page = new NewsDetailController();
      break;
    default:
      // init generic page controller for other templates
      page = new PageController();
      break;
  }

  /*
   * Global elements
   */
  var footerSubscribeForm = new FooterSubscribeForm('#footer-subscribe-form');
  var footerContactForm = new FooterContactForm('#footer-contact-form');

  /*
   * Init share links
   */
  SharingUtils.initShareLinks();

  /*
   * Legacy global elements
   * TODO cleanup, remove unused, move to page controllers
   */
  var nav = new NavComponent();
  var form = new FormComponent();
});